<div>
  {{ 'page.error.500.title' | translate }}
</div>
